import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import Placeholder from 'Components/Placeholder';
import Portal from 'Edits/Portal';

registerBlockType('eformv4/user-portal', {
	title: __('Centralized User Portal - eForm', 'ipt_fsqm'),
	icon: 'admin-users',
	category: 'eform-v4',
	attributes: {
		...eFormGTB.attributes['user-portal'],
	},

	edit({ attributes, className, setAttributes }) {
		const title = __('Centralized User Portal', 'ipt_fsqm');
		const message = __(
			'A central page for users to see their submissions.',
			'ipt_fsqm'
		);
		return (
			<Placeholder className={className} title={title} message={message}>
				<Portal attributes={attributes} setAttributes={setAttributes} />
			</Placeholder>
		);
	},

	save() {
		return null;
	},
});
